import { IApiSuccessResponse } from '../models/Api';
import { TaxAffectsType } from '../models/Tax';
import Api from '../services/api';

export interface ITaxAmountResponse {
  taxAmount: number
  subtotal: number
  total: number
}

export function getCheckoutTaxAmount(taxAmounts?: ITaxAmountResponse | null): number {
  if (taxAmounts == null || !Number.isFinite(taxAmounts.taxAmount)) {
    return 0;
  }

  return taxAmounts.taxAmount;
}

export function getTaxAmount(type: TaxAffectsType, amount: number, zip: string): Promise<IApiSuccessResponse<ITaxAmountResponse>> {
  return Api
    .get({
      url: '/tax/amount',
      query: {type, amount, zipCode: zip}
    })
    .then((res:IApiSuccessResponse<ITaxAmountResponse>) => res);
}
